import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const About = () => {
  return (
    <div className="py-16 relative">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-12">
          Somos VGBComputers, Tu Socio Tecnológico
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h2 className="text-2xl font-semibold mb-4">
              Nuestra Historia
            </h2>
            <p className="text-gray-600 mb-4 text-justify">
              Fundada en 2001 en Santa Cruz de Tenerife, VGBComputers nació con la visión de ofrecer soluciones informáticas profesionales adaptadas a las necesidades específicas de cada cliente.
            </p>
            <p className="text-gray-600 mb-4 text-justify">
              Lo que comenzó como una pequeña empresa de soporte técnico, ha evolucionado hasta convertirse en un referente en servicios tecnológicos avanzados, incorporando soluciones de Inteligencia Artificial, ciberseguridad y cloud computing.
            </p>
            <p className="text-gray-600 text-justify">
              Hoy, con más de 20 años de experiencia, seguimos comprometidos con la excelencia y la innovación, ayudando a empresas canarias a transformar digitalmente sus negocios.
            </p>
          </div>
          <div className="bg-gray-100 p-8 rounded-lg">
            <h2 className="text-xl font-semibold mb-6">
              Nuestros Valores Fundamentales
            </h2>
            <ul className="space-y-4">
              <li className="flex items-start">
                <SafeIcon icon={FiIcons.FiCheckCircle} className="h-6 w-6 text-blue-600 mr-3 mt-1" />
                <div>
                  <h3 className="font-semibold">Excelencia</h3>
                  <p className="text-gray-600">Nos esforzamos por superar las expectativas en cada proyecto.</p>
                </div>
              </li>
              <li className="flex items-start">
                <SafeIcon icon={FiIcons.FiCheckCircle} className="h-6 w-6 text-blue-600 mr-3 mt-1" />
                <div>
                  <h3 className="font-semibold">Innovación</h3>
                  <p className="text-gray-600">Incorporamos continuamente las tecnologías más avanzadas.</p>
                </div>
              </li>
              <li className="flex items-start">
                <SafeIcon icon={FiIcons.FiCheckCircle} className="h-6 w-6 text-blue-600 mr-3 mt-1" />
                <div>
                  <h3 className="font-semibold">Compromiso</h3>
                  <p className="text-gray-600">Nos involucramos completamente en el éxito de nuestros clientes.</p>
                </div>
              </li>
              <li className="flex items-start">
                <SafeIcon icon={FiIcons.FiCheckCircle} className="h-6 w-6 text-blue-600 mr-3 mt-1" />
                <div>
                  <h3 className="font-semibold">Confianza</h3>
                  <p className="text-gray-600">Construimos relaciones sólidas y duraderas basadas en la honestidad.</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="bg-blue-600 text-white rounded-lg p-8 mb-16 text-center">
          <h2 className="text-3xl font-semibold mb-4">
            Nuestra Misión y Visión
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-6">
            <div>
              <SafeIcon icon={FiIcons.FiTarget} className="h-12 w-12 mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-3">Misión</h3>
              <p>
                Proporcionar soluciones tecnológicas innovadoras que impulsen el crecimiento y la eficiencia de nuestros clientes, con un servicio personalizado y de máxima calidad.
              </p>
            </div>
            <div>
              <SafeIcon icon={FiIcons.FiEye} className="h-12 w-12 mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-3">Visión</h3>
              <p>
                Ser reconocidos como líderes en transformación digital en Canarias, ayudando a las empresas a aprovechar todo el potencial de las nuevas tecnologías.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Botón para volver arriba */}
      <button
        onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}
        className="fixed bottom-6 right-6 bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-all z-50"
        aria-label="Volver arriba"
      >
        <SafeIcon icon={FiIcons.FiArrowUp} className="h-6 w-6" />
      </button>
    </div>
  );
};

export default About;